import { render, staticRenderFns } from "./Residency.vue?vue&type=template&id=239020a4&"
import script from "./Residency.vue?vue&type=script&lang=js&"
export * from "./Residency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports